"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
exports.CSS = {
    container: 'c-AnchorInput',
    inputs: 'c__AnchorInput__inputs',
    error: 'c-AnchorInput__error',
    leftInput: 'c-AnchorInput__leftInput',
    rightInput: 'c-AnchorInput__rightInput',
    relatedSpans: 'c-AnchorInput__relatedSpans',
    MDL: {
        error: 'mdl-textfield__error'
    }
};
exports.Style = (_a = {},
    _a[exports.CSS.container] = {
        display: 'block',
        margin: '8px 0',
        width: '100%'
    },
    _a[exports.CSS.inputs] = (_b = {
            flex: 1,
            display: 'flex',
            'justify-content': 'space-between'
        },
        _b["& .".concat(exports.CSS.leftInput)] = {
            width: '60%'
        },
        _b["& .".concat(exports.CSS.rightInput)] = {
            width: '40%'
        },
        _b),
    _a[exports.CSS.error] = {
        visibility: 'visible',
        position: 'relative'
    },
    _a[exports.CSS.relatedSpans] = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    },
    _a);
//# sourceMappingURL=anchor.input.style.js.map